module.exports = __webpack_public_path__ + "static/media/animated_ashutosh.be4f4800.png";